import React from "react";

type Props = {
  children: React.ReactNode;
  hideNavbar?: boolean;
};

const PageLayout = (props: Props): React.ReactElement => {
  const { hideNavbar } = props;
  const url: string = window.location.pathname;

  return (
    <>
      {url === "/" ? null : (
        <div style={{ height: !hideNavbar ? "45px" : 0, width: "100%" }} />
      )}
      {props.children}
    </>
  );
};

export default PageLayout;
